import "./src/styles/global.css";
import { EVENTS } from "./src/constants/events";
import { initPostHog, capture } from "./src/utils/analytics";

export const onClientEntry = () => {
  initPostHog();
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  capture(EVENTS.PAGEVIEW, {
    $current_url: window.location.href,
    path: location.pathname,
    referrer: prevLocation?.href || document.referrer,
  });
};
